import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ImageModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

const enum fields {
    bannerNumber = "bannerNumber",
    fallbackImage = "fallbackImage",
}

type Props = WidgetProps & HasProduct & {
    fields: {
        [fields.bannerNumber]: number;
        [fields.fallbackImage]: string;
    };
};

export interface GAIAProductDetailsBannerStyles {
    wrapper?: InjectableCss;
    banner?: LazyImageProps;
}

export const pdpBannerStyles: GAIAProductDetailsBannerStyles = {
    wrapper: {
        css: css`
            width: 100%;
            margin: 2rem 0;
        `,
    },
    banner: {
        css: css`
            width: 100%;
            height: auto;
            display: block;
        `,
    },
};

const styles = pdpBannerStyles;
const GAIAProductDetailsBanner: React.FC<Props> = ({ product, fields }) => {
    if (!product) {
        return null;
    }

    const bannerImageName = `Banner_${fields.bannerNumber}`;
    const productBannerImage = product.images?.find((img: ImageModel) => img.name === bannerImageName);
    const imagePath = productBannerImage?.largeImagePath || fields.fallbackImage;
    
    if (!imagePath) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="pdp-banner">
            <LazyImage
                {...styles.banner}
                src={imagePath}
                altText={productBannerImage?.imageAltText || product.productTitle}
            />
        </StyledWrapper>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const widgetModule: WidgetModule = {
    component: withProduct(GAIAProductDetailsBanner),
    definition: {
        displayName: "GAIA Product Banner",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.bannerNumber,
                displayName: "Banner Number",
                editorTemplate: "IntegerField",
                defaultValue: 1,
                min: 1,
                fieldType: "General",
                sortOrder: 1,
                tab: basicTab,
            },
            {
                name: fields.fallbackImage,
                displayName: "Fallback Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 2,
                tab: basicTab,
            },
        ],
    },
};

export default widgetModule; 